import React from 'react';
import './Incorrect.css';

const Incorrect = (props) => (
    <div className="Incorrect">{props.message}</div>
);

export default Incorrect;


// WEBPACK FOOTER //
// ./src/components/Utils/Incorrect.js